import React from 'react';
import PropTypes, { string } from 'prop-types';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownToggle from 'react-bootstrap/DropdownToggle';
import DropdownMenu from 'react-bootstrap/DropdownMenu';
import DropdownItem from 'react-bootstrap/DropdownItem';
import { getKeyName } from '../containers/helpers/getKeyName';

function DropDownSelect(props) {
  const { disabled, data = [], value, dropdownKeys, onClick, className } = props;
  return (
    <Dropdown disabled={disabled}>
      <DropdownToggle disabled={disabled} variant={'fff'} size={'sm'} className={className}>
        {getKeyName(data.filter((obj) => obj.id === value)[0], dropdownKeys)}
      </DropdownToggle>
      <DropdownMenu>
        {data
          .filter((obj) => obj.id !== value)
          .map((obj) => {
            const { id } = obj;
            return (
              <DropdownItem key={id} onClick={() => onClick(id)} style={{ cursor: 'pointer' }}>
                {getKeyName(obj, dropdownKeys)}
              </DropdownItem>
            );
          })}
      </DropdownMenu>
    </Dropdown>
  );
}

DropDownSelect.propTypes = {
  value: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
  dropdownKeys: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
  className: string,
};
DropDownSelect.defaultProps = {};

export default DropDownSelect;
